// ** Redux Imports
import { combineReducers } from 'redux'

// ** Reducers Imports
import auth from './auth'
import navbar from './navbar'
import layout from './layout'
import store_PageStructureReducer from "./store_PageStructure/store_PageStructure"
import {store_PageData} from "./store_PageData/store_PageData"
import {store_Repositories} from "./store_Repositories/store_Repositories"
import {store_ProjectData} from "./store_ProjectData/store_ProjectData"
import {store_userData} from "./store_userData/store_userData"
import {store_langKeys} from "./store_langKeys/store_langKeys";
import {store_Navigation} from "./store_Navigation/store_Navigation";
import {store_PageStructure} from "./store_PageStructure/store_PageStructure";

const rootReducer = combineReducers({
  auth,
  navbar,
  layout,
  store_PageStructure,
  store_PageData,
  store_Repositories,
  store_ProjectData,
  store_userData,
  store_langKeys,
  store_Navigation,
})

export default rootReducer
